export const X_URL = "https://x.com/ori_cott?s=21&t=f8qsmQyFycfCj8RnouZYSQ";
